module.exports = __webpack_public_path__ + "assets/img/logo.60eeb006.png";